import { AuthRequestContractError } from './auth-requests.js';
import { isDateTimePreferences } from './date-time-metadata.js';
import { birthdayProfileWrite } from '@liquid-spirit/date-time/birthday';

const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const text = value => typeof value === 'string' && value.trim().length > 0;
const password = value => typeof value === 'string' && value.length > 0;
export const AUTH_PROFILE_FIELDS = ['firstName', 'lastName', 'email', 'phoneNumber', 'address', 'birthday', 'birthdayDate', 'occupation', 'skills', 'preferredLanguage', 'dateTimePreferences', 'profilePicture', 'socialMedia'];
const socialFields = ['facebook', 'x', 'twitter', 'linkedin', 'instagram', 'tiktok'];
const nullableText = value => value === null || typeof value === 'string';
const fail = detail => { throw new AuthRequestContractError(detail); };
export function readAuthRecoveryRequest(body) {
  if (!record(body) || !text(body.email) || body.brand !== undefined && typeof body.brand !== 'string') fail('expected email text and optional brand text.');
  return body;
}
export function readAuthResetPasswordRequest(body) {
  if (!record(body) || !text(body.token) || !password(body.newPassword)) fail('expected reset token and new password strings.');
  return body;
}
export function readAuthChangePasswordRequest(body) {
  if (!record(body) || !password(body.currentPassword) || !password(body.newPassword)) fail('expected current and new password strings.');
  return body;
}
export function readAuthResetTokenRequest(token) {
  if (!text(token)) fail('expected a reset token string.');
  return token;
}
export function readAuthIdentityPathRequest(value) {
  if (!text(value)) fail('expected an identity string.');
  return value;
}
export function readAuthEmailCodeRequest(body) {
  // Numeric OTPs remain supported for existing clients; never stringify objects.
  if (!record(body) || !(typeof body.code === 'string' && /^\d{6}$/.test(body.code.trim())
    || typeof body.code === 'number' && Number.isInteger(body.code) && body.code >= 100000 && body.code <= 999999)) fail('expected a six-digit email code.');
  return body;
}
export function readAuthEmailResendRequest(body = {}) {
  if (!record(body) || body.brand !== undefined && typeof body.brand !== 'string') fail('expected an optional brand string.');
  return body;
}
export function readAuthProfileUpdateRequest(body) {
  if (!record(body) || !AUTH_PROFILE_FIELDS.some(key => Object.hasOwn(body, key))) fail('expected at least one writable profile field.');
  try { birthdayProfileWrite(body); } catch { fail('invalid birthday calendar fields.'); }
  for (const key of AUTH_PROFILE_FIELDS) {
    if (!Object.hasOwn(body, key)) continue;
    const value = body[key];
    const valid = ['firstName', 'lastName', 'email'].includes(key) ? text(value)
      : key === 'skills' ? Array.isArray(value) && value.every(item => typeof item === 'string')
        : key === 'dateTimePreferences' ? isDateTimePreferences(value)
        // Keep the legacy empty-string clearing value accepted by the backend.
        : key === 'birthday' || key === 'birthdayDate' ? true
          : key === 'socialMedia' ? value === null || record(value) && socialFields.every(field => !Object.hasOwn(value, field) || nullableText(value[field]))
            : nullableText(value);
    if (!valid) fail(`invalid ${key} profile field.`);
  }
  return body;
}
export function readAuthVerificationStartRequest(body) {
  if (!record(body) || !text(body.bahaiId) || !text(body.email)) fail('expected Bahai ID and email strings.');
  return body;
}
export function readAuthVerificationListQuery(status) {
  if (status !== undefined && (typeof status !== 'string' || status !== '' && !['pending', 'approved', 'denied'].includes(status.toLowerCase()))) fail('expected a supported verification status string.');
  return status;
}
export function readAuthVerificationReviewRequest(requestId, body) {
  if (typeof requestId !== 'string' || !/^[a-f0-9]{24}$/i.test(requestId) || !record(body)
    || !['approved', 'denied'].includes(body.decision)
    || body.note != null && (typeof body.note !== 'string' || body.note.length > 500)) fail('expected a verification ObjectId, decision and optional note up to 500 characters.');
  return body;
}
